import React from "react";

import TitleSection from "../TitleSection/TitleSection";

import styles from "./ImportantInfos.module.sass";

const ImportantInfos = () => {
  return (
    <div className={styles.ImportantInfos}>
      <TitleSection title="Agora que você escolheu qual consórcio quer adquirir, antes de continuar, é importante saber:"></TitleSection>
      <ul className={styles.InfosList}>
        <li>
          <i className="icon icon-pagamento" />
          <p>
            O pagamento é feito somente por{" "}
            <strong>débito em conta Caixa ou boleto bancário.</strong>
          </p>
        </li>
        <li>
          <i className="icon icon-anexar" />
          <p>
            Após a compra, você precisará{" "}
            <strong>assinar o contrato de forma eletrônica</strong>, por e-mail
            ou SMS.
          </p>
        </li>
        <li>
          <i className="icon icon-meu-seguro" />
          <p>
            Se você é pessoa física, alguns documentos são necessários, como:
            <strong> identidade, comprovante de renda e CPF</strong>. Se for
            pessoa jurídica, precisamos do{" "}
            <strong>
              contrato social ou estatuto, balanço, DRE e balancete
            </strong>
            .
          </p>
        </li>
      </ul>
    </div>
  );
};

export default ImportantInfos;
